import React, { useState, useContext } from 'react';
import Dialog from 'src/components/Dialog';
import moment from 'moment';
import { TextField } from '@material-ui/core';
import { doc } from 'firebase/firestore';
import { useFirestore,useFirestoreDocData } from 'reactfire';
import {onSubmitOfflineFishingCount} from 'src/views/harvesting/fruit-profile/fruit-profile-single/fruit-profile-write';
import { AuthContext } from 'src/context/AuthContext';
import {useKeyPress} from 'src/hook/use-keypress';
import { useAlertContext } from 'src/context/AlertContext';

interface OfflineFishingReportDialogProps {
  dialogOpen: boolean;
  closeDialog: ()=>void;
}
export const OfflineFishingReportDialog: React.VFC<OfflineFishingReportDialogProps> = ({
  dialogOpen,
  closeDialog,
}) => {
  const escKeyPressed = useKeyPress('Esc');
  
  const enterKeyPressed = useKeyPress('Enter');
  const [isSubmiting, setIsSubmiting]=useState(false);
  const db = useFirestore();
  const [offlineFishingResult, setOfflineFishingResult] = useState<number|null>(null);
  const { user } = useContext(AuthContext);
  const memberCounterRef = doc(db, 'reportCounter',moment().format('MM-DD-YYYY'),'members',user.userId);
 
 
  const { data: memberCounter} = useFirestoreDocData(memberCounterRef);
  const previousOfflineFishingResult = memberCounter!=null?memberCounter.offlineFishingCount??0:0;
  const {useAlert} = useAlertContext();


  const onSubmit = ()=>{
    if(offlineFishingResult==null){
      useAlert('Offline fishing can not be blank','warning');

    }
    else if(!isSubmiting){
      console.log('calling submit',JSON.stringify(isSubmiting));
      setIsSubmiting(true);
      onSubmitOfflineFishingCount(
        db,
        user.id,
        user.name,
        user.group,
        user.team,
        previousOfflineFishingResult,
        offlineFishingResult??0
      )
        .then(()=>{
          closeDialog();
          setIsSubmiting(false);
        });
    }
   
  };
  if(enterKeyPressed){
    onSubmit();
  }
  if(escKeyPressed){
    alert('g');
  }

  return (
    <Dialog
      title={'Offline fishing result'}
      description={'Please tell us your offline fishing result'}
      buttons={[
        {
          name: 'Save result',
          type:'submit',
          isLoading: isSubmiting,
          color: 'primary',
          clickFunc: () => {
            onSubmitOfflineFishingCount(
              db,
              user.id,
              user.name,
              user.group,
              user.team,
              previousOfflineFishingResult,
              offlineFishingResult??0
            );
            closeDialog();
          },
          varient: 'contained',
        },
        {
          name: 'Close',
          isLoading: false,
          color: 'secondary',
          clickFunc: () => closeDialog(),
          varient: 'contained',
        },
      ]}
      open={true}
    >
      <TextField
        fullWidth
        variant="filled"
        InputProps={{ inputProps: { min: 0} }}
        label="How many fishes?"
        type="number"
        value={offlineFishingResult}
        onChange={(e) => setOfflineFishingResult(e.target.value?+e.target.value:null)}
      />
    </Dialog>
  );
};

export default OfflineFishingReportDialog;
